// extracted by mini-css-extract-plugin
export default {"hideScrollbar":"a0a023e3","textarea":"ed9ca288"};